var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
let impl = null;
export function registerConfirmImpl(fn) {
    impl = fn;
}
export function confirm(opts) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        if (impl)
            return impl(opts);
        const text = (opts.title ? opts.title + "\n\n" : "") + ((_a = opts.message) !== null && _a !== void 0 ? _a : "");
        return Promise.resolve(window.confirm(text));
    });
}
